<template>
    <div v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="row" style="padding: 5px">
      <div class="col-12 mb-4">
          <div class=" pb-4">
          <v-btn @click="$router.go(-1)" outlined style="border: none;background: #fff" title="Retourner">
            <v-icon>mdi mdi-arrow-left</v-icon> Menu
           </v-btn>
        </div>
          <div class="mt-3 mb-0 pb-0">
                  <v-alert type="info">
                      {{ $t('business_client_entry')}}
                  </v-alert>
              </div>
        <v-card elevation="0" class="mt-4">
                <v-data-table
                    :headers="headers"
                    :items="classes"
                    :search="search"
                    sort-by="label"
                    class="elevation-1"
                    :loading="loadings.classes"
                    loading-text="Chargement en cours...">
                  <template v-slot:item._created_at="{item}">
                    {{ new Date(item._created_at).toLocaleDateString() }}
                  </template>
                  <template v-slot:item.actions="{ item }">
                  <div style="text-align:  right">
                    <v-menu
                        key="text"
                        rounded="b-xl">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                            class="black--text "
                            v-bind="attrs"
                            v-on="on">mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                            v-for="(action_item, index) in actions_items"
                            :key="index"
                            link
                            @click="editItemAction(item,index)">
                          <v-list-item-icon>
                            <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
  
                </template>
                  
                  <template v-slot:top>
                    <v-row style="background: #f8f8f8;">
                      <v-col cols="12" sm="4">
                        <v-text-field solo
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="background: #f8f8f8;">
                      <v-toolbar
                          flat
                      >
                        <v-toolbar-title >Frais de {{ school?._name }} </v-toolbar-title>
                        <v-spacer/> 
                        <v-dialog
                            v-model="dialogCustomer"
                            max-width="700px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="secondary"
                                dark
                                class="mb-2"
                                v-bind="attrs"
                                v-on="on"
                            >
                              Ajouter un frais
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-text >
                              <v-form ref="clientForm" v-model="clientFormIsValid">
                                <v-container v-show="classestep===1">
                                  <v-row>
                                    <v-col lg="12">
                                      <h3 class="pb-5">Ajouter un nouveau frais</h3>
                                      <!-- <h4 style="font-weight:bold">
                                       Informations l'école
                                      </h4> -->
                                    </v-col>
                                    <div class="col-12">
                                      <v-btn class="btn btn-light btn-sm" text @click="dialogSheetUpload = true, dialogCustomer = false" >
                                      <v-icon>mdi-microsoft-excel</v-icon>  Ajouter via un fichier xlxs
                                      </v-btn>
                                    </div>
                                    
                                    <v-col lg="6" sm="12">
                                       <label for="">Nom </label>
                                    <v-text-field solo
                                        v-model="feeToSave._name"
                                        :rules="requiredRules"
                                        label="Nom"
                                    ></v-text-field>
                                    </v-col>
                                    
                                  </v-row>
                               
                                   <v-row>
                                 
                                    <v-col lg="8" sm="12">
                                       <label for="">Montant par défaut (applicable a toutes les classes)</label>
                                       <v-text-field solo
                                        v-model="feeToSave._defaultValue"
                                        type="number"
                                        label="Montant"
                                    ></v-text-field>
                                    </v-col>
                                  </v-row> 
                                </v-container>
                              </v-form>
                            </v-card-text>
  
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                  color="dark"
                                  @click="dialogCustomer = false, editingCustomer = false"
                              >
                                Annuler
                              </v-btn>
                       
                              <v-btn
                                  v-if="!editingCustomer"
                                  :loading="loadings.fee_saving"
                                  color="primary"
                                   :disabled="feeToSave._name===null "
                                  @click="saveFee()"
                              >
                                Enregistrer
                              </v-btn>
                              <v-btn
                                  v-if="editingCustomer"
                                  :loading="loadings.fee_saving"
                                   :disabled="feeToSave._name===null "
                                  color="primary"
                                  @click="updateFee()"
                              >
                               Mettre à jour
                              </v-btn>
  
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </v-row>
                  </template>
  
                  <template v-slot:item._category="{ item }">
                    <div>
                      {{ item._category ? item._category._name : 'N/A' }}
                    </div>
                  </template>
                  <template v-slot:item._phone="{ item }">
                    <div>
                      {{ item._prefix ? item._prefix+''+item._phone : +item._phone }}
                    </div>
                  </template>
  
                
  
                  <template v-slot:no-data>
                    <span>{{ $t('fees.notFound') }}</span>
                  </template>
                </v-data-table>
                <div class="col-12 text-right" style="background : #f8f8f8">
                  <v-pagination
                  elevation="0"
                  v-model="page"
                  :length="total_pages"
                  :total-visible="7"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="getMarchandCustomers"
                  ></v-pagination>
                <!-- product pagination -->
              </div>
           
           
        </v-card>
      </div>
      <v-dialog
          v-model="dialogTransaction"
          persistent
          scrollable
          max-width="600px"
      >
        <v-card>
  
          <v-card-text class="mt-5">
            <div v-if="categories && classes && products">
            <h5 class="mb-4">
              Générer une transaction
            </h5>
            <label>Générer une transaction pour:</label>
            <v-radio-group v-model="forCategoryClient" row class="mt-0 pt-0">
              <v-radio label=" Une Catégorie de client" :value="true">
              </v-radio>
              <v-radio label=" Un ou plusieur classes" :value="false">
              </v-radio>
            </v-radio-group>
  
            <v-row>
              <v-col col="12">
              <label> Sélectionner une option</label> <br>
              <v-select solo multiple v-if="forCategoryClient" :items="categories" item-text="_name" item-value="_id"
                        label="Sélectionner une catégorie de client" v-model="selected_category_client"></v-select>
              <v-select solo multiple v-if="!forCategoryClient" :items="classes" item-text="_first_name" item-value="_id"
                        label="Sélectionner un ou des classes" v-model="selected_client_transaction"></v-select>
              </v-col>
            </v-row>
  
               <v-row>
                 <v-col col="12">
                    <label> Libellé des transactions</label> <br>
                    <v-text-field solo v-model="transaction_name" label="Libellé de la transaction"></v-text-field>
                 </v-col>
            </v-row>
  
            <v-row>
                    <div class="col-12 col-lg-8">
                        <v-checkbox
                        class="mt-0 pt-0 mb-0 pb-0"
                          v-model="fees_support"
                          label="Supporter les frais de transaction"
                        ></v-checkbox>
                    </div>
                </v-row>
  
            <v-card
                outlined
                class="pt-0 pb-0"
            >
              <v-card-text class="pb-0">
                <v-row>
                  <h5 class="col-12">Choisissez les produits à associer à cette transaction.</h5>
                  <v-col cols="12" sm="7"  md="7" class="pb-0 mb-0">
                  <label> Choisir un produit</label>
                    <v-select solo
                        label="Choisir un produit"
                        :items="products"
                        item-text="_name"
                        item-value="_id"
                        v-model="currentProduct"
                        return-object
                        required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" class="pb-0 mb-0">
                  <label> Quantité</label>
                    <v-text-field solo
                        label="Quantité"
                        v-model="currentQuantity"
                        type="number"
                        required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" class="mt-0 pt-lg-5 mt-lg-5">
                    <v-btn  color="secondary" @click="addProductToTransaction"> + ajouter</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-container>
              <v-row v-if="transaction_products.length > 0">
                <v-data-table style="width: 100%;" :items="transaction_products" :headers="transaction_products_header">
                  <template v-slot:item.actions="{ item }">
                    <v-btn text @click="transaction_products.splice(transaction_products.indexOf(item), 1)">
                      <v-icon color="red">
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-row>
              <v-row v-if="transaction_products.length === 0">
                <v-alert
                type="warning"
                    elevation="0"
                >
                Vous devez associer des produits à cette transaction pour continuer ...
                </v-alert>
              </v-row>
            </v-container>
            </div>
            <div v-else>
              <div >
                 <h3> Certaines configuration préalable sont nécessaires pour ajouter une transaction</h3>
                 <div class="alert alert-warning" v-if="!categories || categories.length <=0"> Ajouter une catégorie de client avant de continuer <router-link to="/customers" > accéder à la page</router-link> </div>
                 <div class="alert alert-warning" v-if="!classes || classes.length <=0"> Ajouter un client avant de continuer <router-link to="/customers"> accéder à la page</router-link> </div>
                 <div class="alert alert-warning" v-if="!products || products.length <=0"> Ajouter un produit  avant de continuer <router-link to="/products"> accéder à la page</router-link> </div>
                  <div>
                    <v-btn color="dark" small @click="resetTransaction()" > Fermer </v-btn>
                  </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions v-if="categories && classes && products">
            <v-spacer></v-spacer>
            <v-btn
                color="dark"
                @click="resetTransaction()"
            >
              annuler
            </v-btn>
            <v-btn
             :disabled="!transaction_products
             || transaction_products.length <= 0
             || !transaction_name
             || transaction_name===''
             || ( forCategoryClient && !selected_category_client
             && selected_category_client.length <=0)
             || (!forCategoryClient && !selected_client_transaction)
             "
                color="primary darken-1"
                @click="saveTransaction"
                :loading="transactionInProgress"
            >
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
     <!-- Importe sheet data -->
      <v-dialog v-model="dialogSheetUpload" max-width="500px" >
  
                              <v-card>
                                <v-card-title>
                                  <h4 class=" pt-4"> Téléverser un fichier sheet</h4>
                                </v-card-title>
  
                                <v-card-text>
                                  <v-form ref="sheetForm">
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12" sm="12">
                                          <label> Quel type de donnée voulez vous importé ? :</label>
                                            <v-radio-group v-model="type_import" row class="pt-0 mt-0">
                                              <v-radio label=" Liste de classes"  value="client" class="mt-1">
                                              </v-radio>
                                              <v-radio label="Liste de Catégories client" class="mt-1" value="categorie">
                                              </v-radio>
                                            </v-radio-group>
                                        </v-col>
                                      <v-col cols="12" sm="12">
                                          <label>Téléverser un fichier xlsx pour ajouter des classes ou des catégories classes en masse.</label>
                                        <v-file-input accept=".xlsx, .xls" :rules="sheetrules" ref="sheet" solo show-size v-model="sheet"></v-file-input>
                                        <h6> Téléchager un modèle xlsx client<a href="/excels/intram-client-model.xlsx" target="_blank" download="intram-client-model.xlsx"> ici </a></h6>
                                        <h6> Téléchager un modèle xlsx categorie client<a href="/excels/intram-categorie-client-model.xlsx" target="_blank" download="intram-categorie-client-model.xlsx"> ici </a></h6>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-form>
                                </v-card-text>
  
                                <v-card-actions class="pt-0 mt-0">
                                  <v-spacer></v-spacer>
                                  <v-col cols="12" sm="12" class="text-right mt-0 pt-0">
                                  <v-btn
                                      color="dark"
                                      @click="dialogSheetUpload= false, sheet=[]"
                                  >
                                    Annuler
                                  </v-btn>
                                  <v-btn class="ml-2"
                                  :disabled="sheet.length <= 0"
                                      color="primary"
                                      type="submit"
                                      :loading="sheetSaving"
                                      @click="saveMassCustomer"
                                  >
                                    Enregistrer
                                  </v-btn>
                                  </v-col>
                                </v-card-actions>
                              </v-card>
      </v-dialog>
     <!-- *********************************** -->
  
    </div>
    <div v-else>
      <go-to-params></go-to-params>
    </div>
  </template>
  
  <script>
  /* eslint-disable */
  import {mapState} from "vuex";
  import GoToParams from "../administrators/globalComponents/GoToParams";
  import {client} from "../../store/services/client";
  import {client as webservice_client} from "../../store/services/webservices-client";
  import {fontAwesomePicker} from 'font-awesome-picker';
  import Swal from "sweetalert2";
  
  export default {
    components: {
      GoToParams,
      'font-awesome-picker': fontAwesomePicker,
    },
    label: "Customers",
    data() {
      return {
        type_import:'client',
        sheet:[],
        sheetrules: [
          value => !value || value.size < 10000000 || 'Avatar size should be less than 10 MB!',
        ],
        dialogSheetUpload:false,
        sheetSaving:false,
        fees_support:false,
        page: 0,
        total_pages: 0,
        classestep:1,
        transaction_name: '',
        currentProduct: null,
        currentQuantity: 1,
        editingCategory: false,
        editingCustomer: false,
        categoryClienFormIsValid: false,
        clientFormIsValid: false,
        selected_client_transaction: [],
        selected_category_client: [],
        transactionInProgress: false,
        requiredRules: [
          v => !!v || 'Ce champ est recquis',
        ],
        loadings: {
          classes: false,
          categories: false,
          categoriySaving: false,
          fee_saving: false
        },
        whatsapp:'',
        tel:'',
        notifier_whatsapp:'',
        notifier_tel:'',
        dialogTransaction: false,
        produits: [],
        classes: undefined,
        school: undefined,
        all_classes: undefined,
        forCategoryClient: false,
        products: [],
        transaction_produits: [],
        client_transaction: null,
        status_transaction: false,
        dialogDeleteCategory: false,
        dialogDelete: false,
        country_key: '',
        lazy: false,
        errors: {},
        search: '',
        dialogCategory: false,
        dialogCustomer: false,
        id: undefined,
        customers_tabs: '',
        feeToSave: {
          _name: '',
          _school: '',
          _defaultValue: ''
        },
        headers: [
          {text: 'Nom', value: '_name'},
          {text: 'Valeur par défaut', value: '_defaultValue'},
          {text: '', value: 'actions'},
        ],
        transaction_products: [],
        editedIndex: -1,
        editedItem: {},
        user_role: '',
        actions_items: [
          // {title: "Créer transaction", avatar: 'mdi-currency-usd'},
          {title: "Modifier", avatar: 'mdi-pencil'},
          {title: "Supprimer", avatar: 'mdi-delete'},
          {title: "Gérer", avatar: 'mdi-eye'},
        ],
  
        categories_actions_items: [
          {title: "Modifier", avatar: 'mdi-pencil'},
          {title: "Supprimer", avatar: 'mdi-delete'},
        ],
        categories: [],
        category: {
          _name: "",
          _description: "",
        }
  
      }
    },
    computed: {
      // ...mapState('users/', ['classes']),
      dialogCategoryTitle() {
        if (this.editingCategory)
          return "Modification de catégorie client";
  
        return "Ajout d'une catégorie de client";
      },
      drop_down_user_countries: function () {
        let arr = [{text: "Tous les utilisateurs", value: -1}];
  
        if (this.countries) {
          this.countries.forEach((country) => {
            arr.push({text: country._name, value: country._id})
          });
        }
  
        return arr;
      },
      ...mapState('countries/', ['countries']),
      formCategoryTitle() {
        return ""
      }
  
    },
    mounted() {
      this.initialize();
      this.$store.dispatch('countries/getCountries').then(response => {
      });
  
    },
    sockets: {
      connect: function () {
        console.log('socket to notification channel connected')
      },
    },
    methods: {
      // getphoneresult($event){
  
      //     this.feeToSave._contactNumber = $event.countryCallingCode + $event.nationalNumber
      // },
      getWhatsappresult($event){
          this.customer._whatsapp = $event.nationalNumber
      },
       getnotifierphoneresult($event){
          this.customer._notifier_phone = $event.nationalNumber
          this.customer._notifier_prefix = $event.countryCallingCode
      },
      getnotifierWhatsappresult($event){
          this.customer._notifier_whatsapp = $event.nationalNumber
      },
      editItemAction(item, index) {
        switch (index) {
          // case 0:
          //   this.dialogTransaction = true;
          //   this.selected_client_transaction.push(item._id);
          //   break;
          case 0:
            this.toggleEditSchool(item);
            break;
          case 1:
            this.toggleDeleteFee(item);
            break;
          case 2:
            this.$router.push({name: 'intramScholar.manage', params: {school_id: item._id}})
            break;
        }
      },
      getAmountFromChoosenProduct(products) {
        let amount = 0
        products.forEach(row => {
          amount += row.product._price * row._quantity
        })
  
        return amount
      },
      async saveTransaction() {
        this.transactionInProgress = true
        const data = {
          transaction_name: this.transaction_name,
          forCategoryClient: this.forCategoryClient,
          _classes: this.selected_client_transaction,
          _products: this.transaction_products,
          _categories: this.selected_category_client,
          _fees_support: this.fees_support,
          _amount: 0
        }
        const amount = this.getAmountFromChoosenProduct(data._products)
        data._amount = amount
  
        // save the transaction in backend
        const response = await client({
          method: 'post',
          url: '/marchand/client_transaction',
          data: {
            data: data,
          }
        })
            .then(res => res.data)
            .catch(error => {
              return {
                error: true
              }
            })
  
  
        if (!response.error) {
          this.dialogTransaction = false
          this.resetTransaction();
        }
        this.transactionInProgress = false
        this.toast(response.type, response.message)
        
      },
      makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() *
              charactersLength));
        }
        return result;
      },
      addProductToTransaction() {
        if (!this.currentProduct)
          return
        const exist = this.transaction_products.filter(x => x.product._id === this.currentProduct._id)
  
        if (exist && exist.length > 0) {
          const index = this.transaction_products.indexOf(exist[0])
  
          this.transaction_products[index].settings._quantity += this.currentQuantity
        } else {
          this.transaction_products.push({
            product: this.currentProduct,
            _product_id: this.currentProduct._id,
            _quantity: this.currentQuantity,
            settings: {
              _quantity: this.currentQuantity,
            }
          })
        }
      },
      async getMarchanProducts() {
        const response = await client({
          method: 'get',
          url: '/marchand/product/get'
        })
            .then(resp => resp.data)
            .catch(error => {
              console.log(error)
              return {
                error: "true"
              }
            })
        if (!response.error) {
          this.products = response.products
        }
      },
      async initialize() {
        if (this.$store.getters.marchand) {
          this.getAllFees()
          this.getSchool()
        }
            
        //   this.getMarchandCustomers()
        // else
        //   this.getAllclasses()
  
        // this.getMarchanProducts()
        // this.getCategories()
        // this.getAllMarchandCustomers();
      },
  
      async getSchool() {
        const response = await client({
          method: 'get',
          url: `/school-payments/schools/${this.$route.params.school_id}`
        })
            .then(resp => resp.data)
            .catch(() => {
              return {
                error: "true"
              }
            })
        if (!response.error)
          this.school = response;
  
          console.log(this.school)
      },
      async getAllMarchandCustomers() {
        const response = await client({
          method: 'get',
          url: 'marchand/marchand_customer/get'
        })
            .then(resp => resp.data)
            .catch(() => {
              return {
                error: "true"
              }
            })
        if (!response.error)
          this.all_classes = response.marchandclasses;
      },
      async getAllFees() {
        this.loadings.classes = true;
        const response = await client({
          method: 'get',
          url: `/school-payments/fees/school/${this.$route.params.school_id}`
        })
            .then(resp => resp.data)
            .catch(error => {
              this.loadings.classes = false;
              return {
                error: "true"
              }
            })
        if (!response.error) {
          this.loadings.classes = false;
          console.log(response)
  
          this.classes = response
  
  
          console.log(this.classes);
        }
      },
      async getCategories() {
        this.loadings.categories = true;
        const response = await client({
          method: 'get',
          url: '/client_category/get'
        })
            .then(resp => resp.data)
            .catch(error => {
              this.loadings.categories = false;
              return {
                error: "true"
              }
            })
        if (!response.error) {
          this.loadings.categories = false;
          this.categories = response.categories
        }
      },
      async saveFee() {
        if (this.$refs.clientForm.validate()) {
          this.loadings.fee_saving = true;
          this.feeToSave._school = this.$route.params.school_id
          const response = await client({
            method: 'post',
            url: '/school-payments/fees',
            data: this.feeToSave
          })
              .then(resp => {
                this.$refs.clientForm.reset();
                console.log(resp.data);
                return resp.data;
              })
              .catch(error => {
                return {
                  error: "true"
                }
              })
          this.loadings.fee_saving = false;
          this.dialogCustomer = false;
          this.getAllFees()
          this.toast(response.type, response.message)
        }
      },
      async saveMassCustomer() {
          this.sheetSaving = true;
          let data = new FormData();
          data.append('sheet',this.sheet);
          data.append('type',this.type_import);
          const response = await client({
            method: 'post',
            url: '/marchand_customer/post/sheet',
            data: data
          })
              .then(resp => {
                this.sheet=[];
                return resp.data;
              })
              .catch(error => {
                return {
                  error: "true"
                }
              })
          this.dialogSheetUpload = false;
          this.sheetSaving = false;
          this.getMarchandCustomers()
          this.getCategories()
          this.toast(response.type, response.message)
      },
      async saveCategory() {
        if (this.$refs.categoryClienForm.validate()) {
          this.loadings.categoriySaving = true;
          const response = await client({
            method: 'post',
            url: '/client_category/post',
            data: this.category
          })
              .then(resp => {
                this.categories = resp.data.categorieclasses;
                this.$refs.categoryClienForm.reset();
                return resp.data;
              })
              .catch(error => {
                return {
                  error: "true"
                }
              })
          this.loadings.categoriySaving = false;
          this.dialogCategory = false;
          this.toast(response.type, response.message)
        }
      },
    
      async updateFee() {
        if (this.$refs.clientForm.validate()) {
          this.loadings.fee_saving = true;
          const response = await client({
            method: 'PUT',
            url: `/school-payments/fees/${this.id}`,
            data: this.feeToSave
          })
              .then(resp => {
                this.$refs.clientForm.reset();
                return resp.data;
              })
              .catch(error => {
                return {
                  error: "true"
                }
              })
          this.loadings.fee_saving = false;
          this.editingCustomer = false;
          this.dialogCustomer = false;
          this.getAllFees()
          this.toast(response.type, response.message)
        }
      },
      toggleEditSchool(item) {
        this.dialogCustomer = true;
        this.editingCustomer = true;
        this.feeToSave = item;
        this.id = item._id;
        console.log(this.id)
      },
      editCategoryItemAction(item, index) {
        switch (index) {
          case 0:
            this.toggleEdtiCategory(item);
            break;
          case 1:
            this.toggleDeleteCategory(item);
            break;
        }
      },
      toggleEdtiCategory(item) {
        this.dialogCategory = true;
        this.editingCategory = true;
        this.category = item;
      },
      toggleDeleteCategory(item) {
        Swal.fire({
          icon: 'warning',
          timerProgressBar: false,
          text: this.$t('delete_warning'),
          confirmButtonText: "Supprimer",
          cancelButtonText: "Annuler",
          showCancelButton: true,
          cancelButtonColor: "#CCC",
          confirmButtonColor: "#29B3A6",
          preConfirm: async () => {
            Swal.showLoading()
            return response = await client({
              method: 'get',
              url: `/client_category/delete/${item._id}`,
            })
                .then(resp => {
                  Swal.hideLoading()
                  Swal.fire({
                    icon: 'success',
                    text: "Suppression réussi",
                    confirmButtonText: "Ok",
                    cancelButtonText: "Annuler",
                    cancelButtonColor: "#CCC",
                    confirmButtonColor: "#29B3A6"
                  });
                  this.categories = resp.data.categorieclasses;
                  return resp.data;
                })
                .catch(error => {
                  return {
                    error: "true"
                  }
                })
          },
          allowOutsideClick: () => !Swal.isLoading()
        }).then(async result => {
          if (result.value) {
  
          }
        })
      },
       resetTransaction(){
        this.transaction_name= "";
        this.forCategoryClient=false;
        this.selected_client_transaction=[];
        this.transaction_products=[];
        this.selected_category_client=[];
        this.currentProduct= null,
        this.currentQuantity= 1,
        this.allTransaction= [],
        this.dialogTransaction = false
        this.fees_support = false
      },
      toggleDeleteFee(item) {
        Swal.fire({
          icon: 'warning',
          timerProgressBar: false,
          text: this.$t('delete_warning'),
          confirmButtonText: "Supprimer",
          cancelButtonText: "Annuler",
          showCancelButton: true,
          cancelButtonColor: "#CCC",
          confirmButtonColor: "#29B3A6",
          preConfirm: async () => {
            Swal.showLoading();
            try {
              const response = await client({
                method: 'delete',
                url: `/school-payments/fees/${item._id}`,
              });
              Swal.hideLoading();
              Swal.fire({
                icon: 'success',
                text: "Suppression réussi",
                confirmButtonText: "Ok",
                cancelButtonText: "Annuler",
                cancelButtonColor: "#CCC",
                confirmButtonColor: "#29B3A6"
              });
              console.log(response);
              await this.getAllFees()
              return response.data;
            } catch (error) {
              Swal.hideLoading();
              Swal.fire({
                icon: 'error',
                text: "Erreur lors de la suppression",
                confirmButtonText: "Ok",
                cancelButtonText: "Annuler",
                cancelButtonColor: "#CCC",
                confirmButtonColor: "#29B3A6"
              });
              return { error: "true" };
            }
          },
          allowOutsideClick: () => !Swal.isLoading()
        }).then(result => {
          console.log(result);
          if (result.isConfirmed) {
            console.log('finish with modal');
            this.getAllFees();
          }
        });
        console.log('finish with modal 2');
      },
      goToUserDetails(id) {
        let url = '/users/' + id;
        this.$router.push(url);
      },
      checkisDashboard() {
        this.$emit('checkisDashboard', true);
      },
      deleteItemConfirm() {
  
      },
      selectCategoryCustomerIcon(icon) {
        this.category._icon = icon.className
      },
      filterUsers(criteria) {
        let VueBox = this;
        this.$store.dispatch('users/filterClient', {
          country_id: VueBox.country_key,
          isMarchand: VueBox.$store.getters.marchand !== null
        })
      },
      getClass(item) {
        return `fa fa-2xl fa-${item._icon}`;
      },
      close() {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
  
      closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    },
    created() {
      this.checkisDashboard();
      this.initialize()
    },
    watch: {
      dialog(val) {
        val || this.close()
      },
      dialogDelete(val) {
        val || this.closeDelete()
      },
    },
  
  }
  </script>
  
  <style scoped>
  .circular--square {
    border-radius: 50%;
  }
  
  .circular--square {
    border-radius: 50% 50%;
    width: 50px;
    height: 50px;
    object-fit: contain;
  }
  svg:not(:host).svg-inline--fa, svg:not(:root).svg-inline--fa{
    font-size: 20px;
  }
  </style>
  